import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  /* max-width: 1320px */
  /* padding-right: 15px;
  padding-left: 15px; */
  margin-right: auto;
  margin-left: auto;
`;
